import { useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSiteBrand } from '../i18n'
import { brandSpeciesSeed } from '../context/contextUrl'

/**
 * Вид домена (`default_species` пака) для холодного входа без вида в ссылке.
 *
 * Бренд приезжает с ответом `/site`, поэтому вид ставится эффектом и ОДИН раз:
 * снятый человеком вид обратно не возвращается. Отдельным хуком, а не в
 * `ViewContext`: тот про язык и бренд домена не знает (`providerOrder.test.ts`).
 */
export function useBrandSpeciesSeed(
  species: number | null,
  setSpecies: (s: number | null) => void,
): void {
  const brandSpecies = useSiteBrand()?.default_species ?? null
  const [searchParams] = useSearchParams()
  const [bootParams] = useState(() => new URLSearchParams(searchParams))
  const doneRef = useRef(false)
  useEffect(() => {
    if (doneRef.current || brandSpecies == null) return
    doneRef.current = true
    const next = brandSpeciesSeed(bootParams, species, brandSpecies)
    if (next != null) setSpecies(next)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandSpecies])
}
